




















































import Countdown from 'components/Countdown.vue'
import LanguageSwitcher from 'components/LanguageSwitcher.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Countdown,
    LanguageSwitcher
  }
})
export default class Logout extends Vue {
  loading: boolean = false

  done: boolean = false

  logout () {
    const formData = { challenge: this.$route.query.logout_challenge, _csrf: this.$q.cookies.get('xsrf') }
    // const headers = { 'CSRF-Token': this.$q.cookies.get('xsrf') }

    this.loading = true

    const form = document.createElement('form')
    form.setAttribute('method', 'post')
    form.setAttribute('action', this.$appConfig.apiBaseUrl + '/logout')
    form.style.display = 'none'

    Object.keys(formData).forEach((name) => {
      const inputField = document.createElement('input')
      inputField.setAttribute('type', 'hidden')
      inputField.setAttribute('name', name)
      inputField.setAttribute('value', String((formData as any)[name]))
      form.appendChild(inputField)
    })

    const submitButton = document.createElement('input')
    submitButton.setAttribute('type', 'submit')
    form.appendChild(submitButton)

    document.getElementsByTagName('body')[0].appendChild(form)

    form.submit()

    // this.done = true

    // this.$axios.post('/logout', formData, { headers: headers, withCredentials: true })
    //   .then(async ({ data }) => {
    //     this.done = true
    //     const redirectTo = data.redirectTo || this.$appConfig.homeUrl
    //     location.replace(redirectTo)
    //   }).catch((e) => {
    //   // console.error(e)
    // }).finally(() => {
    //   this.loading = false
    // })
  }
}
